import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dc319c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approve_form container-lg container-fluid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Innovator Registration Form")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, [
  /*#__PURE__*/_createTextVNode(" Section 1: Applicant Details "),
  /*#__PURE__*/_createElementVNode("small", { class: "span_color" }, "Information regarding applicant personal and contact details")
], -1))
const _hoisted_4 = { class: "p-float-label prime_input mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Individual = _resolveComponent("Individual")!
  const _component_Organization = _resolveComponent("Organization")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          id: "group",
          modelValue: _ctx.group,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group) = $event)),
          options: _ctx.groups,
          optionLabel: "name",
          placeholder: "Applying as an individual or business/Organisation",
          class: "w-100"
        }, null, 8, ["modelValue", "options"])
      ]),
      (_ctx.groupId !== 'ORGANIZATION')
        ? (_openBlock(), _createBlock(_component_Individual, {
            key: 0,
            id: _ctx.id
          }, null, 8, ["id"]))
        : (_ctx.groupId === 'ORGANIZATION')
          ? (_openBlock(), _createBlock(_component_Organization, {
              key: 1,
              id: _ctx.id
            }, null, 8, ["id"]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Footer)
  ]))
}